
export const useShouldShowOrgOriginals = ({totalAdminTrainerCount, isMfwOnMfwPlatform, isClient, option}:{
  totalAdminTrainerCount: number;
  isMfwOnMfwPlatform: boolean;
  isClient: boolean;
  option: boolean;
}): boolean => {
  // BEFORE:
  // adminsTrainers > 1 && 
  // organizationId !== process.env.REACT_APP_MFW_ORGANIZATION_ID &&  Samo mfe na mfw platf ne vidi?
  // !isClient && 
  // options.showORGOriginals

  const userPermission = totalAdminTrainerCount>1; // Ako si jedini u org svakako vec vidis ceo org kontent
  const orgPermission = !isMfwOnMfwPlatform;
  const shouldShow = option && userPermission && orgPermission;

  return shouldShow;
};